import { DbEntityProvider } from './db-entity.provider';
import { DbDaoService, GetAllDataOptions } from '../db/db-dao.service';
import { UPDATES_TYPES } from '@shared/constants/updates-types.const';
import { Observable } from 'rxjs';
import { VirtualPrinter } from '@shared/classes/virtual-printer.class';
import { Injectable } from '@angular/core';
import { Query } from '@paymash/capacitor-database-plugin';

@Injectable()
export class VirtualPrintersProvider extends DbEntityProvider {
  constructor(dbDaoService: DbDaoService) {
    super(UPDATES_TYPES.VirtualPrinter.type, dbDaoService);
  }

  getByUuid(uuid: string): Observable<VirtualPrinter> {
    return <Observable<VirtualPrinter>>this.getEntityByUuid(uuid);
  }

  getList(): Observable<VirtualPrinter[]> {
    return <Observable<VirtualPrinter[]>>this.getEntitiesList();
  }

  getListByParams(queryParams: Query, options?: GetAllDataOptions): Observable<VirtualPrinter[]> {
    return <Observable<VirtualPrinter[]>>this.getEntitiesListByParams(queryParams, options).pipe(this.mapPipeTransformEntities());
  }
}
